import { ComponentWithTooltip } from 'components/ComponentWithTooltip';
import { ContractOtherStatusEnum, type ContractOtherCostItemData } from 'gql/graphql';
import { IconAlert } from 'uikit';
import { EMPTY_DRAFT_OTHER_TYPE_MSG, EMPTY_OTHER_FORMULA_MSG, EMPTY_OTHER_TYPE_MSG } from 'utils/constants';

import { cnMixSpace } from '@consta/uikit/MixSpace';
import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';

type INameCellRenderer = ICellRendererParams<ContractOtherCostItemData>;

const style = { display: 'flex', alignItems: 'center' };

export const NameCellRenderer: React.FC<INameCellRenderer> = (props) => {
    const { data } = props;

    const withTooltip = data?.hasEmptyOtherCostType || data?.hasEmptyFormula;
    const cellValue = data?.name ?? '';
    const tooltipContent = (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
            className="Text Text_lineHeight_m Text_size_xs Text_view_primary"
        >
            {data?.hasEmptyOtherCostType && data.status !== ContractOtherStatusEnum.Draft && (
                <span>{EMPTY_OTHER_TYPE_MSG}</span>
            )}
            {data?.hasEmptyOtherCostType && data.status === ContractOtherStatusEnum.Draft && (
                <span>{EMPTY_DRAFT_OTHER_TYPE_MSG}</span>
            )}
            {data?.hasEmptyFormula && (
                <span
                    className={
                        data?.hasEmptyOtherCostType
                            ? cnMixSpace({
                                  mT: '2xs',
                              })
                            : undefined
                    }
                >
                    {EMPTY_OTHER_FORMULA_MSG}
                </span>
            )}
        </div>
    );

    if (withTooltip) {
        return (
            <div style={style}>
                <ComponentWithTooltip tooltipText={tooltipContent} styles={style}>
                    <IconAlert
                        className={cnMixSpace({
                            mR: 's',
                        })}
                        view="alert"
                        size="s"
                    />
                </ComponentWithTooltip>
                <div>{cellValue}</div>
            </div>
        );
    }

    return <span>{cellValue}</span>;
};

NameCellRenderer.displayName = 'NameCellRenderer';
